import React from "react";
import { ErrorMessage } from "formik";

const Step0PropertyType = ({ values, setFieldValue, state, submitted, errors }) => {
    return (
        <div className="step_tags">
            <ul>
                {state.stateTypes &&
                    state.stateTypes.length > 0 &&
                    state.stateTypes.map((val, key) => {
                        return (
                            <li
                                key={key}
                                onClick={() => setFieldValue("property_type_id", val.id)}
                                className={
                                    values.property_type_id == val.id ? "active" : "step_item"
                                }
                            >
                                <div className="step_item">
                                    <img height={25} width={22} src={val.image_url} alt={val.eng_title} />
                                    <h3>{val.eng_title.toUpperCase()}</h3>
                                </div>
                            </li>
                        );
                    })}
            </ul>

            {submitted && errors.property_type_id && (
                <ErrorMessage
                    name="property_type_id"
                    component="div"
                    className="errorStyle"
                />
            )}
        </div>
    );
};

export default Step0PropertyType;
